var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.03 499.32C91.01 409.93 195.58 360.43 269.4 336.31C437.08 284.04 663.29 283.48 825.63 354.07C882.08 379.66 946.93 422.52 950.11 490.95C951.06 536.36 919.77 575.22 885.49 601.26C783.03 676.51 645.91 699.01 521.56 702.24C395.56 702.78 260.82 683.09 155.23 609.06C120.24 583.59 87.95 545.03 88.03 499.32ZM103.64 499.17C105.11 539.57 134.56 571.35 166.47 593.46C234.37 639.02 317.55 658.24 397.89 669.09C520.28 683.67 647.17 677.95 765.05 640.31C832.33 618.06 933.25 571.9 936.44 491.08C936.27 449.93 907.13 416.48 875.35 393.03C790.3 332.69 682.78 311.85 580.31 304.26C476.42 297.93 370.21 308.64 271.84 343.47C205.1 368.09 104.31 418.04 103.64 499.17Z",
    fill: "url(#paint0_linear_102_371)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M751.21 129.62C823.8 181.87 806.69 296.3 785.61 371.05C735.65 539.43 610.16 727.64 461.11 823.17C408.42 855.81 336.71 885.81 278.1 850.35C239.85 825.85 225 778.22 222.46 735.25C217.01 608.25 274.68 481.82 341.24 376.74C410.96 271.78 502.35 170.83 622.63 124.35C663.27 109.44 713.29 104.09 751.21 129.62ZM742.64 142.67C708.26 121.39 665.47 128.16 629.33 142.35C553.68 173.38 491.39 231.76 437.64 292.45C357.38 385.99 291.47 494.57 257.09 613.45C238.1 681.72 220.25 791.25 285.6 838.91C319.87 861.68 363.89 856.11 401.06 842.77C498.54 805.73 575.72 728.03 639.09 647.14C702.2 564.38 752.45 470.19 778.3 369.09C795.02 299.93 809.66 188.4 742.64 142.67Z",
    fill: "url(#paint1_linear_102_371)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M285.16 141.17C217.46 187.15 231.55 300.03 249.06 369.46C269.71 450.51 307.77 526.28 353.87 595.74C400.28 664.78 455.54 728.77 521.58 779.66C574.97 819.51 647.75 864.4 716.13 848.65C766.84 835.61 785.59 781.98 786.58 734.18C787.84 577.58 690.05 409.63 591.61 292.02C538 230.65 476.36 172 400.03 140.79C363.5 126.37 319.98 119.58 285.16 141.17ZM278.55 131.11C316.03 105.89 365.31 111.22 405.56 125.89C559.22 185.77 681.22 342.23 750.2 487.53C785.41 564.87 813.04 649.21 808.59 735.36C805.76 791.3 780.31 851.76 720.35 865.42C645.33 880.72 570.85 832.15 515.14 787.78C434.14 720.62 369.13 635.64 317.82 544.22C268.85 453.37 225.48 350.77 227.02 245.76C228.23 203.38 241.55 156.25 278.55 131.11Z",
    fill: "url(#paint2_linear_102_371)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.46 539.04C111.176 539.04 128.78 521.436 128.78 499.72C128.78 478.004 111.176 460.4 89.46 460.4C67.7442 460.4 50.14 478.004 50.14 499.72C50.14 521.436 67.7442 539.04 89.46 539.04Z",
    fill: "url(#paint3_linear_102_371)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M89.46 539.04C111.176 539.04 128.78 521.436 128.78 499.72C128.78 478.004 111.176 460.4 89.46 460.4C67.7442 460.4 50.14 478.004 50.14 499.72C50.14 521.436 67.7442 539.04 89.46 539.04Z",
    fill: "url(#paint4_linear_102_371)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M89.46 539.04C111.176 539.04 128.78 521.436 128.78 499.72C128.78 478.004 111.176 460.4 89.46 460.4C67.7442 460.4 50.14 478.004 50.14 499.72C50.14 521.436 67.7442 539.04 89.46 539.04Z",
    fill: "url(#paint5_linear_102_371)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M89.46 539.04C111.176 539.04 128.78 521.436 128.78 499.72C128.78 478.004 111.176 460.4 89.46 460.4C67.7442 460.4 50.14 478.004 50.14 499.72C50.14 521.436 67.7442 539.04 89.46 539.04Z",
    fill: "url(#paint6_linear_102_371)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M89.45 460.62C67.85 460.62 50.35 478.13 50.35 499.72C50.35 521.32 67.86 538.82 89.45 538.82C111.05 538.82 128.55 521.31 128.55 499.72C128.56 478.13 111.05 460.62 89.45 460.62ZM85.7 522.3C70.42 522.3 58.03 509.91 58.03 494.63C58.03 479.35 70.42 466.96 85.7 466.96C100.98 466.96 113.37 479.35 113.37 494.63C113.37 509.91 100.98 522.3 85.7 522.3Z",
    fill: "url(#paint7_linear_102_371)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M83.18 480.5C83.18 483.46 80.78 485.86 77.82 485.86C74.86 485.86 72.46 483.46 72.46 480.5C72.46 477.54 74.86 475.14 77.82 475.14C80.78 475.14 83.18 477.54 83.18 480.5Z",
    fill: "#CB5AFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M74.33 489.85C74.33 491.47 73.02 492.78 71.4 492.78C69.78 492.78 68.47 491.47 68.47 489.85C68.47 488.23 69.78 486.92 71.4 486.92C73.02 486.92 74.33 488.24 74.33 489.85Z",
    fill: "#CB5AFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M725.91 890.83C747.626 890.83 765.23 873.226 765.23 851.51C765.23 829.794 747.626 812.19 725.91 812.19C704.194 812.19 686.59 829.794 686.59 851.51C686.59 873.226 704.194 890.83 725.91 890.83Z",
    fill: "url(#paint8_linear_102_371)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M725.91 890.83C747.626 890.83 765.23 873.226 765.23 851.51C765.23 829.794 747.626 812.19 725.91 812.19C704.194 812.19 686.59 829.794 686.59 851.51C686.59 873.226 704.194 890.83 725.91 890.83Z",
    fill: "url(#paint9_linear_102_371)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M725.91 812.4C704.31 812.4 686.81 829.91 686.81 851.5C686.81 873.1 704.32 890.6 725.91 890.6C747.51 890.6 765.01 873.09 765.01 851.5C765.02 829.91 747.51 812.4 725.91 812.4ZM722.15 874.08C706.87 874.08 694.48 861.69 694.48 846.41C694.48 831.13 706.87 818.74 722.15 818.74C737.43 818.74 749.82 831.13 749.82 846.41C749.82 861.69 737.44 874.08 722.15 874.08Z",
    fill: "url(#paint10_linear_102_371)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M725.91 890.83C747.626 890.83 765.23 873.226 765.23 851.51C765.23 829.794 747.626 812.19 725.91 812.19C704.194 812.19 686.59 829.794 686.59 851.51C686.59 873.226 704.194 890.83 725.91 890.83Z",
    fill: "url(#paint11_linear_102_371)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M725.91 890.83C747.626 890.83 765.23 873.226 765.23 851.51C765.23 829.794 747.626 812.19 725.91 812.19C704.194 812.19 686.59 829.794 686.59 851.51C686.59 873.226 704.194 890.83 725.91 890.83Z",
    fill: "url(#paint12_linear_102_371)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M719.64 832.28C719.64 835.24 717.24 837.64 714.28 837.64C711.32 837.64 708.92 835.24 708.92 832.28C708.92 829.32 711.32 826.92 714.28 826.92C717.24 826.93 719.64 829.33 719.64 832.28Z",
    fill: "#6B8BFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M710.79 841.64C710.79 843.26 709.48 844.57 707.86 844.57C706.24 844.57 704.93 843.26 704.93 841.64C704.93 840.02 706.24 838.71 707.86 838.71C709.48 838.71 710.79 840.02 710.79 841.64Z",
    fill: "#6B8BFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M786.21 238.68C807.926 238.68 825.53 221.076 825.53 199.36C825.53 177.644 807.926 160.04 786.21 160.04C764.494 160.04 746.89 177.644 746.89 199.36C746.89 221.076 764.494 238.68 786.21 238.68Z",
    fill: "url(#paint13_radial_102_371)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M786.21 238.68C807.926 238.68 825.53 221.076 825.53 199.36C825.53 177.644 807.926 160.04 786.21 160.04C764.494 160.04 746.89 177.644 746.89 199.36C746.89 221.076 764.494 238.68 786.21 238.68Z",
    fill: "url(#paint14_linear_102_371)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M786.21 238.68C807.926 238.68 825.53 221.076 825.53 199.36C825.53 177.644 807.926 160.04 786.21 160.04C764.494 160.04 746.89 177.644 746.89 199.36C746.89 221.076 764.494 238.68 786.21 238.68Z",
    fill: "url(#paint15_linear_102_371)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M786.21 238.68C807.926 238.68 825.53 221.076 825.53 199.36C825.53 177.644 807.926 160.04 786.21 160.04C764.494 160.04 746.89 177.644 746.89 199.36C746.89 221.076 764.494 238.68 786.21 238.68Z",
    fill: "url(#paint16_linear_102_371)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M779.61 184.38C779.61 187.34 777.21 189.74 774.25 189.74C771.29 189.74 768.89 187.34 768.89 184.38C768.89 181.42 771.29 179.02 774.25 179.02C777.21 179.02 779.61 181.42 779.61 184.38Z",
    fill: "#6EFAC3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M770.76 193.73C770.76 195.35 769.45 196.66 767.83 196.66C766.21 196.66 764.9 195.35 764.9 193.73C764.9 192.11 766.21 190.8 767.83 190.8C769.45 190.8 770.76 192.11 770.76 193.73Z",
    fill: "#6EFAC3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M786.21 160.25C764.61 160.25 747.11 177.76 747.11 199.35C747.11 220.95 764.62 238.45 786.21 238.45C807.81 238.45 825.31 220.94 825.31 199.35C825.31 177.76 807.81 160.25 786.21 160.25ZM782.45 221.93C767.17 221.93 754.78 209.54 754.78 194.26C754.78 178.98 767.17 166.59 782.45 166.59C797.73 166.59 810.12 178.98 810.12 194.26C810.12 209.55 797.73 221.93 782.45 221.93Z",
    fill: "url(#paint17_linear_102_371)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M447.66 523.71C447.66 508.34 459.85 496.69 475.76 496.69C491.67 496.69 503.86 508.34 503.86 523.71C503.86 538.95 491.67 550.54 475.72 550.54C459.82 550.54 447.66 538.95 447.66 523.71ZM490.11 523.61C490.11 515.7 483.89 509.61 475.76 509.61C467.63 509.61 461.41 515.71 461.41 523.61C461.41 531.49 467.63 537.55 475.76 537.55C483.89 537.55 490.11 531.49 490.11 523.61Z",
    fill: "#8223D2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M510.53 498.05H529.87C540.41 498.05 549.21 505.99 549.21 515.99C549.21 525.87 540.6 534.15 529.87 534.15H524.12V549.23H510.53V498.05ZM536.1 516.06C536.1 512.95 533.5 510.6 529.88 510.6H524.13V521.62L529.88 521.65C533.52 521.68 536.1 519.2 536.1 516.06Z",
    fill: "#8223D2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M552.32 540.57L560.54 532.5C562.67 535.64 566.64 537.55 570.92 537.55C573.81 537.55 576.64 536.5 576.64 534.41C576.64 531.77 571.4 529.46 566.38 527.23C559.9 524.44 554.34 520.18 554.34 512.46C554.34 503.6 562.76 497.28 572.47 497.28C580.28 497.28 586.38 500.96 588.38 506.01L580.54 513.57C579.02 510.87 575.08 509.7 572.63 509.7C569.84 509.7 567.83 511.13 567.83 512.88C567.83 515.23 571.45 515.99 576.98 518.31C584.98 521.68 590.29 526.57 590.29 534.12C590.29 543.87 581.21 549.93 570.95 549.93C562.55 549.94 554.9 546.22 552.32 540.57Z",
    fill: "#8223D2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M495.01 487.66H542.52V345.62L447.66 369.3V397.77L495.01 385.94V487.66Z",
    fill: "#6E767D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M589.88 560.65H447.66V588.3H589.88V560.65Z",
    fill: "#6E767D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_371",
    x1: 29.6856,
    y1: 414.604,
    x2: 958.645,
    y2: 577.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB5AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#FF5070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#A839F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6415,
    stopColor: "#A839F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    stopColor: "#6700B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_102_371",
    x1: 222.109,
    y1: 489.073,
    x2: 803.838,
    y2: 489.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3142,
    stopColor: "#00E7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7307,
    stopColor: "#6EFAC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8896,
    stopColor: "#D2FA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87FAA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_102_371",
    x1: 792.183,
    y1: 912.588,
    x2: 508.057,
    y2: 470.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1827,
    stopColor: "#CB5AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3483,
    stopColor: "#6B8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6313,
    stopColor: "#4A68F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2743CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_102_371",
    x1: 66.5132,
    y1: 470.768,
    x2: 113.6,
    y2: 530.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB5AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5037,
    stopColor: "#8223D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    stopColor: "#6700B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_102_371",
    x1: 67.6922,
    y1: 467.079,
    x2: 111.122,
    y2: 532.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CB5AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B8BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_102_371",
    x1: 67.6922,
    y1: 467.079,
    x2: 111.122,
    y2: 532.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CB5AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B8BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_102_371",
    x1: 70.5738,
    y1: 467.899,
    x2: 108.365,
    y2: 531.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_102_371",
    x1: 69.1889,
    y1: 482.054,
    x2: 151.248,
    y2: 553.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_102_371",
    x1: 691.753,
    y1: 814.587,
    x2: 752.097,
    y2: 879.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5663,
    stopColor: "#4A68F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    stopColor: "#2743CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_102_371",
    x1: 704.149,
    y1: 818.862,
    x2: 747.579,
    y2: 884.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFAC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4A68F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    stopColor: "#A839F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_102_371",
    x1: 705.646,
    y1: 833.837,
    x2: 787.705,
    y2: 905.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B8BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_102_371",
    x1: 704.149,
    y1: 818.862,
    x2: 747.579,
    y2: 884.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFAC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4A68F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    stopColor: "#A839F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_102_371",
    x1: 707.031,
    y1: 819.682,
    x2: 744.822,
    y2: 883.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_102_371",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(760.562 162.217) scale(71.3204 71.3204)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFAC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4896,
    stopColor: "#00E7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B574"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_102_371",
    x1: 764.446,
    y1: 166.713,
    x2: 807.876,
    y2: 231.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFAC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6491F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A839F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_102_371",
    x1: 764.446,
    y1: 166.713,
    x2: 807.876,
    y2: 231.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0302,
    stopColor: "#6EFAC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6491F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A839F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_102_371",
    x1: 767.328,
    y1: 167.533,
    x2: 805.119,
    y2: 231.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_102_371",
    x1: 765.943,
    y1: 181.688,
    x2: 848.002,
    y2: 253.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E7A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.93fd7e98096f31be77e9c127bf1cc6b6.svg";
export { ForwardRef as ReactComponent };